<template>
  <transition name="mobile-fade">
    <div
      v-show="mobileMenuStore.isOpened"
      class="mobile-menu"
      :class="{ active: mobileMenuStore.isOpened }"
    >
      <div class="mobile-menu-container">
        <div v-if="authStore.isLoggedIn" class="mobile-authenticated">
          <template v-for="item in menuStore.allMenuItems" :key="item.id">
            <a
              v-if="item.isButton"
              href="#"
              @click.prevent="onButtonClick(item)"
            >
              {{ item.label }}
            </a>

            <router-link v-else :to="{ name: item.to }">
              {{ item.label }}
            </router-link>
          </template>
        </div>
        <div
          v-else-if="route.name !== 'account-login'"
          class="mobile-menu-not-authenticated"
        >
          <sign-in-link></sign-in-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps } from 'vue'
import { mobileMenuStore } from '@/stores/mobile-menu'
import { useAuthStore } from '@/stores/auth'
import { useMenuStore } from '@/stores/menu'
import { useRouter, useRoute } from 'vue-router'
import { getUserData } from '@core/auth/utils'
import { startOrder } from '@core/composables/order/startOrder'
import { OrderTypes } from '@modules/app-steps/step-two/tabs/tabs-data'

import SignInLink from './sign-in-link.vue'

defineProps({
  isOpen: { type: Boolean, default: true },
  rightFlexEnd: { type: Boolean, default: false },
})

const authStore = useAuthStore()
const menuStore = useMenuStore()
const router = useRouter()
const route = useRoute()
const { executeStartOrder } = startOrder()

const onLogOut = () => authStore.logout(route)

const handleMiscPurchase = async () => {
  const { firstName, lastName, phone } = getUserData()

  const order = await executeStartOrder({
    firstName,
    lastName,
    phone,
    orderType: OrderTypes.MiscSale,
  })

  const orderId = order?.value?.id
  if (!orderId) return

  router.push({ name: 'order-misc-sale', params: { id: orderId } })
}

const onButtonClick = async (item) => {
  if (!item.action) return
  if (item.action === 'logout') return onLogOut()
  if (item.action === 'miscPurchase') return handleMiscPurchase()
}
</script>
